import { render } from "./dimensionalMirror.vue?vue&type=template&id=3b821302&scoped=true"
import script from "./dimensionalMirror.vue?vue&type=script&lang=js"
export * from "./dimensionalMirror.vue?vue&type=script&lang=js"

import "./dimensionalMirror.vue?vue&type=style&index=0&id=3b821302&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b821302"]])

export default __exports__